import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayConfettiIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M7.72002 11.27C7.31002 10.86 6.73002 10.68 6.16002 10.79C5.59002 10.9 5.12002 11.27 4.88002 11.8L0.890023 20.8C0.590023 21.47 0.740023 22.23 1.25002 22.75C1.77002 23.27 2.54002 23.4 3.20002 23.11L12.2 19.11C12.73 18.88 13.1 18.4 13.21 17.83C13.32 17.26 13.13 16.68 12.73 16.27L7.73002 11.27H7.72002ZM2.59002 21.74C2.46002 21.8 2.37002 21.74 2.31002 21.69C2.25002 21.64 2.20002 21.54 2.26002 21.41L4.80002 15.69L8.31002 19.2L2.59002 21.74ZM11.59 17.74L9.53002 18.65L5.34002 14.46L6.25002 12.4C6.30002 12.3 6.38002 12.27 6.43002 12.26C6.44002 12.26 6.46002 12.26 6.48002 12.26C6.53002 12.26 6.59002 12.27 6.65002 12.33L11.65 17.33C11.73 17.41 11.73 17.5 11.72 17.55C11.72 17.6 11.68 17.68 11.58 17.73L11.59 17.74Z"
        fill={color}
      />
      <path
        d="M20.3 15.19C20.42 15.31 20.58 15.37 20.74 15.37C20.9 15.37 21.06 15.31 21.18 15.19C21.42 14.95 21.42 14.55 21.18 14.31C19.28 12.41 16.19 12.41 14.3 14.31C14.06 14.55 14.06 14.95 14.3 15.19C14.54 15.43 14.94 15.43 15.18 15.19C16.59 13.78 18.89 13.78 20.3 15.19Z"
        fill={color}
      />
      <path
        d="M8.60999 9.48999C8.84999 9.72999 9.24999 9.72999 9.48999 9.48999C11.94 7.03999 11.94 3.05999 9.48999 0.609993C9.24999 0.369993 8.84999 0.369993 8.60999 0.609993C8.36999 0.849993 8.36999 1.24999 8.60999 1.48999C10.57 3.44999 10.57 6.63999 8.60999 8.60999C8.36999 8.84999 8.36999 9.24999 8.60999 9.48999Z"
        fill={color}
      />
      <path
        d="M5.63 4H4.62C4.27758 4 4 4.27758 4 4.62V5.63C4 5.97242 4.27758 6.25 4.62 6.25H5.63C5.97242 6.25 6.25 5.97242 6.25 5.63V4.62C6.25 4.27758 5.97242 4 5.63 4Z"
        fill={color}
      />
      <path
        d="M18.38 20.75H17.37C17.0276 20.75 16.75 21.0276 16.75 21.37V22.38C16.75 22.7224 17.0276 23 17.37 23H18.38C18.7224 23 19 22.7224 19 22.38V21.37C19 21.0276 18.7224 20.75 18.38 20.75Z"
        fill={color}
      />
      <path
        d="M13.63 9H12.62C12.2776 9 12 9.27758 12 9.62V10.63C12 10.9724 12.2776 11.25 12.62 11.25H13.63C13.9724 11.25 14.25 10.9724 14.25 10.63V9.62C14.25 9.27758 13.9724 9 13.63 9Z"
        fill={color}
      />
      <path
        d="M21.38 17H20.37C20.0276 17 19.75 17.2776 19.75 17.62V18.63C19.75 18.9724 20.0276 19.25 20.37 19.25H21.38C21.7224 19.25 22 18.9724 22 18.63V17.62C22 17.2776 21.7224 17 21.38 17Z"
        fill={color}
      />
      <path
        d="M19.63 8H18.62C18.2776 8 18 8.27758 18 8.62V9.63C18 9.97242 18.2776 10.25 18.62 10.25H19.63C19.9724 10.25 20.25 9.97242 20.25 9.63V8.62C20.25 8.27758 19.9724 8 19.63 8Z"
        fill={color}
      />
      <path
        d="M17.63 1.75H16.62C16.2776 1.75 16 2.02758 16 2.37V3.38C16 3.72242 16.2776 4 16.62 4H17.63C17.9724 4 18.25 3.72242 18.25 3.38V2.37C18.25 2.02758 17.9724 1.75 17.63 1.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayConfettiIcon.displayName = 'PayConfettiIcon';
